<template>
  <div class="w-full flex flex-col items-center py-[2rem] md:py-[2rem]">
    <PanelTipo5 
      texto="¿Te has preguntado cómo funciona el sistema de climatización de tu automóvil?" 
      textoboton="Ver más"
      clasetexto="text-center md:text-normal"
      @ver-mas="irAHigienizacion"
    />
  </div>
</template>

<script setup>
import PanelTipo5 from "~/components/Paneles/PanelTipo5.vue";

const irAHigienizacion = () => {
  navigateTo('/higienizacion');
};
</script>